var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-switch"},[_c('rhcn-drawer',{on:{"on-close":_vm.onClose}},[_c('div',{staticClass:"switch-content"},[_c('MerchantSwitch')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }